/**
 * Step 4 — recap + final CTAs. Pure client recap of the two real choices
 * (language + module). Exam-date row is cut (Decision E1 — no backend).
 */
import { MODULE_DEFINITIONS, type ModuleSlug } from "@a2/core";
import { LOCALE_DISPLAY, type Locale } from "@a2/i18n/config";
import { useT } from "../../../lib/use-t";

function DoneIcon() {
  return (
    <span
      className="mb-5 grid h-16 w-16 place-items-center rounded-full text-white"
      style={{ background: "var(--pass)", boxShadow: "0 10px 24px -10px rgba(90,166,125,.6)" }}
    >
      <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M5 12l5 5L20 6" />
      </svg>
    </span>
  );
}

export function StepKlaar({ lang, module }: { lang: Locale; module: ModuleSlug }) {
  const t = useT();
  return (
    <div>
      <DoneIcon />
      <p className="font-mono-badge text-[11px] uppercase tracking-[0.14em] text-[var(--ink-faint)]">
        {t("onboarding.klaar.eyebrow")}
      </p>
      <h1 className="mt-3 text-[26px] font-semibold tracking-tight lg:text-[32px]">
        {t("onboarding.klaar.title")}
      </h1>
      <dl className="my-6 rounded-[var(--radius)] border border-[var(--border)] bg-[var(--panel)] px-[18px]">
        <div className="flex items-center gap-3 border-b border-[var(--border)] py-3 text-[14.5px]">
          <dt className="w-[120px] flex-none text-[var(--ink-muted)]">{t("onboarding.klaar.recapLanguage")}</dt>
          <dd className="font-semibold">{LOCALE_DISPLAY[lang].endonym}</dd>
        </div>
        <div className="flex items-center gap-3 py-3 text-[14.5px]">
          <dt className="w-[120px] flex-none text-[var(--ink-muted)]">{t("onboarding.klaar.recapStartWith")}</dt>
          <dd className="font-semibold">{MODULE_DEFINITIONS[module].label}</dd>
        </div>
      </dl>
      <p className="font-serif-italic text-[19px] leading-[1.45] text-[var(--ink-muted)]">
        {t("onboarding.klaar.lead")}
      </p>
    </div>
  );
}
